export default __webpack_public_path__ + "static/media/IBMPlexSans-Bold.2642e569.woff";